import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { MaintenanceComponentDto } from './models/MaintenanceComponentDto';
import { MaintenanceComponentsSearchCriteria } from './models/MaintenanceComponentsSearchCriteria';

class MaintenanceComponentsService {
    public getList(criteria: MaintenanceComponentsSearchCriteria) {
        return Http.get<Paged<MaintenanceComponentDto>>('maintenancecomponents', criteria);
    }

    public catalog() {
        return Http.get<SelectValueLabel[]>('maintenancecomponents/catalog');
    }

    public getById(id: string) {
        return Http.get<MaintenanceComponentDto>('maintenancecomponents/' + id);
    }

    public create(model: MaintenanceComponentDto) {
        return Http.post<string>('maintenancecomponents', model);
    }

    public update(model: MaintenanceComponentDto) {
        return Http.put('maintenancecomponents', model);
    }

    public remove(model: MaintenanceComponentDto) {
        return Http.put('maintenancecomponents/deactivate', model);
    }
}

export default new MaintenanceComponentsService();
